import React from 'react';
import { identifyComponent } from '../../util';
import css from './index.module.scss';

export const Middot = () => (
  <span data-component="Middot" className={css.middot} {...identifyComponent('middot')}>
    &middot;
  </span>
);
